import { render, staticRenderFns } from "./send_mail_modal.vue?vue&type=template&id=1ab4c0f7&scoped=true"
import script from "./send_mail_modal.vue?vue&type=script&lang=js"
export * from "./send_mail_modal.vue?vue&type=script&lang=js"
import style0 from "./send_mail_modal.vue?vue&type=style&index=0&id=1ab4c0f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4c0f7",
  null
  
)

export default component.exports